import confetti from "canvas-confetti";

export function confettiWin() {
    //hier von 10 auf 3 geändert
    const confettiDuration = 3 * 1000;
    const confettiEnd = Date.now() + confettiDuration;

    const confettiInterval = setInterval(() => {
        if (Date.now() >= confettiEnd) return clearInterval(confettiInterval);

        let particleCount = (70 * (confettiEnd - Date.now())) / confettiDuration;

        const randomInRange = (min, max) => {
            return Math.random() * (max - min) + min;
        };

        const conf = (x, y) => {
            confetti({
                startVelocity: 30,
                spread: 120,
                //hier von 60 auf 30 geänder
                ticks: 30,
                zIndex: 0,
                particleCount: particleCount,
                origin: {
                    x: x,
                    y: y,
                },
            });
        };

        conf(randomInRange(0.1, 0.3), Math.random() - 0.2);
        conf(randomInRange(0.7, 0.9), Math.random() - 0.2);
    }, 250);
};